import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  ButtonToolbar,
  Modal,
  Dropdown,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  CardHeaderTitle,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  fetchId,
  fetchRole,
  selectRole,
  selectDataId,
  editItem,
  addOfficeUser,
  selectDataIdUser,
  fetchIdUser,
  editEmployee,
  removeUserOffice,
  unlockUserUpdate,
  resetUserUpdate,
  selectRoleModal,
  fetchRoleModal,
  editOfficeUser,
} from "../user/userSlice";
import {
  checkMenu,
  dateDefault,
  formLabelsTheme,
  formatDate,
  getValueOptions,
  iconError,
  showConfirmDialog,
  showDeleteDialog,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  sizePerPageList,
  useForceUpdate,
  useStyles,
  useStylesReddit,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import { fetchOffice, selectOffice } from "../office/officeSlice";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  toAbsoluteUrl,
  headerSortingClasses,
} from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

import { makeStyles, fade, ThemeProvider } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import {
  fetchParameter,
  fetchParameter2,
  fetchParameter3,
  fetchParameter4,
  selectParameter,
  selectParameter2,
} from "../businessParameter/businessParameterSlice";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  MenuItem,
  Radio,
  RadioGroup,
} from "@material-ui/core";

import { fetchClient } from "../client/clientSlice";
import { selectPagination } from "../../modules/Auth";
import {
  editInbound,
  fetchIdInbound,
  fetchListInspection,
  fetchVehicleMaintenance,
  selectIdInbound,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  selectVehicle,
} from "../inbound/inboundSlice";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import {
  PickingPage,
  WorkflowMaintenancePage,
} from "./WorkflowMaintenancePage";
import { InspectPage } from "./InspectPage";
import {
  fetchIdMaintenance,
  selectIdMaintenance,
  selectPermissionList,
  setPermisionInspect,
  setPermisionList,
  setPermisionMaintenance,
  setPermisionRepdiin,
  setPermisionRepdiout,
} from "./maintenanceSlice";
import { RePDIINPage } from "./RePDIINPage";
import { RePDIOUTPage } from "./RePDIOUTPage";
import {
  fetchMenuTab,
  selectLoadingMenu,
  selectMenuTab,
} from "../menu/menuSlice";
import { ErrorPermissionPage } from "../../utility/ErrorPermissionPage";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const WorkflowMaintenance = (params) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectIdMaintenance);
  const data = useSelector(selectVehicle);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const dataService = useSelector(selectParameter);
  const dataJobType = useSelector(selectParameter2);
  const { id } = useParams();
  const paginationSet = useSelector(selectPagination);
  const forceUpdate = useForceUpdate();

  const [value, setValue] = useState(0);
  const [force, setForce] = useState(false);

  const [paramFilter, setParamFilter] = useState("");
  const [paramValue, setParamValue] = useState("");

  const dataMenuTab = useSelector(selectMenuTab);
  const loadingMenu = useSelector(selectLoadingMenu);
  const dataMenuList = useSelector(selectPermissionList);

  // permison

  const [active, setActive] = useState("");
  const [list, setList] = useState([]);

  // initial
  const dataParams = params.location.state;
  console.log(dataMenuList, "dataMenuList");
  console.log(dataMenuTab, "dataMenuTab");

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      let result;

      if (dataParams === 0) {
        result = "5140,5141";
      } else if (dataParams === 1) {
        result = "5143,5210,5211";
      }

      await dispatch(fetchIdMaintenance(id));

      await dispatch(
        fetchMenuTab({
          menu_url: "/motor-pool/maintenance",
        })
      );

      await dispatch(fetchListInspection());

      setValue(dataParams);
      await dispatch(
        fetchVehicleMaintenance({
          maintenance_id: id,
          is_planned: "Y,N",
          vehicle_status: result,
          pageNo: 1,
          pageSize: paginationSet,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    // Add number
    if (force === true) {
      handleSearch();
      forceUpdate();
      setParamValue("");
      setParamFilter("");
      setValueTab(0);
      setForce(false);
    }
  }, [force]);

  useEffect(() => {
    if (dataMenuTab.length > 0) {
      const data = dataMenuTab.map((item) => item.menu_name);
      setList(data);
      dispatch(setPermisionList(data));
      const master = dataMenuTab.map((item, index) => {
        if (item.menu_name === "Maintenance") {
          return dispatch(setPermisionMaintenance(item.permissions));
        }
        if (item.menu_name === "Inspection") {
          return dispatch(setPermisionInspect(item.permissions));
        }
        if (item.menu_name === "PDI-In") {
          return dispatch(setPermisionRepdiin(item.permissions));
        }
        if (item.menu_name === "PDI-Out") {
          return dispatch(setPermisionRepdiout(item.permissions));
        }
      });
    }
  }, [dataMenuTab]);

  const handleSearch = async () => {
    let result;

    if (value === 0) {
      result = "5140,5141";
    } else if (value === 1) {
      result = "5143,5210,5211";
    }
    let params = {};
    params.maintenance_id = id;
    params.vehicle_status = result;
    params.is_planned = "Y,N";
    params.pageNo = 1;
    params.pageSize = paginationSet;

    try {
      const response = await dispatch(fetchVehicleMaintenance(params));
      if (response.payload.data.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleChangeTab = (event, newValue) => {
    console.log("Changing tab from", value, "to", newValue);

    setValue(newValue);
    forceUpdate();
    setForce(true);
  };

  const [valueTab, setValueTab] = useState(0);

  const [formData, setFormData] = useState({
    maintenancevehicle_id: {
      value: "",
      error: false,
      required: "Y"
    },
    vehicle_id: {
      value: "",
      error: false,
      required: "Y"
    },
    vin: {
      value: "",
      error: false,
      required: "Y",
    },
    von: {
      value: "",
      error: false,
      required: "N",
    },
    maintenance_remarks: {
      value: "",
      error: false,
      required: "N",
    },
    maintenance_date: {
      value: "",
      error: false,
      required: "Y",
    },
  });

  const [formInspect, setFormInspect] = useState({
    vin: {
      value: "",
      error: false,
      required: "Y",
    },
    remarks: {
      value: "",
      error: false,
      required: "N",
    },
    inspection_date: {
      value: "",
      error: false,
      required: "N",
    },
    inspection_result: {
      value: "",
      error: false,
      required: "N",
    },
  });

  const [show, setShow] = useState(false);
  const [showScan, setShowScan] = useState(false);

  // formVehicle
  const [getData, setGetData] = useState(false);
  const [getDataHandover, setGetDataHandover] = useState(false);
  const [getDataBTS, setGetDataBTS] = useState(false);

  const [create, setCreate] = useState(false);

  const [columnsInspection, setColumnsInspection] = useState([]);
  const [listInspection, setListInspection] = useState([]);
  const [detailDamage, setDetailDamage] = useState([]);
  const [rowInspection, setRowInspection] = useState(null);
  const [rowIndexInspection, setRowIndexInspection] = useState(null);
  const [showDetailDamage, setShowDetailDamage] = useState(false);
  const [inspectoinResult, setInspectoinResult] = useState("OK");

  return loading || loadingMenu ? (
    <LayoutSplashScreen />
  ) : (
    <>
      {dataId && (
        <>
          <Card>
            <CardBody>
              <div className="d-flex justify-content-between mt-5 mb-5">
                <p className=" font-size-h3 text-title-primary font-weight-boldest">
                  Activity Monitor
                </p>
              </div>
              <div className="d-flex justify-content-between mt-5 mb-5">
                <p className=" font-size-h3 text-title-primary font-weight-boldest">
                  Maintenance Job : {dataId.maintenance_no}
                </p>
              </div>

              {/* Header */}

              <div
                className="m-2 d-flex bg-primary-dark align-items-center"
                style={{ borderRadius: "10px" }}
              >
                <div className="m-2 flex-fill font-weight-boldest  text-white ml-5">
                  Workflow
                </div>
              </div>
              <>
                <Tabs
                  value={value}
                  onChange={handleChangeTab}
                  indicatorColor="primary"
                  textColor="primary"
                  fullWidth
                >
                  {checkMenu(dataMenuList, "Maintenance") ? (
                    <Tab
                      label={`Maintenance : ${dataId.maintenance_status_workflow} >`}
                    />
                  ) : (
                    <Tab
                      disabled
                      label={`Maintenance : You Dont Have Permission >`}
                    />
                  )}
                  {checkMenu(dataMenuList, "Inspection") ? (
                    <Tab
                      label={`Inspection : ${dataId.inspect_status_workflow} >`}
                    />
                  ) : (
                    <Tab
                      disabled
                      label={`Inspection : You Dont Have Permission >`}
                    />
                  )}
                </Tabs>
                {value === 0 && (
                  <>
                    {checkMenu(dataMenuList, "Maintenance") ? (
                      <WorkflowMaintenancePage
                        active={value}
                        paramFilter={paramFilter}
                        setParamFilter={setParamFilter}
                        paramValue={paramValue}
                        setParamValue={setParamValue}
                        value={valueTab}
                        setValue={setValueTab}
                        formValues={formData}
                        setFormValues={setFormData}
                        show={show}
                        setShow={setShow}
                        showScan={showScan}
                        setShowScan={setShowScan}
                        getData={getData}
                        setGetData={setGetData}
                        create={create}
                        setCreate={setCreate}
                      />
                    ) : (
                      <ErrorPermissionPage />
                    )}
                  </>
                )}

                {value === 1 && (
                  <>
                    {checkMenu(dataMenuList, "Inspection") ? (
                      <InspectPage
                        active={value}
                        paramFilter={paramFilter}
                        setParamFilter={setParamFilter}
                        paramValue={paramValue}
                        setParamValue={setParamValue}
                        value={valueTab}
                        setValue={setValueTab}
                        formValues={formInspect}
                        setFormValues={setFormInspect}
                        show={show}
                        setShow={setShow}
                        showScan={showScan}
                        setShowScan={setShowScan}
                        showDetailDamage={showDetailDamage}
                        setShowDetailDamage={setShowDetailDamage}
                        create={create}
                        setCreate={setCreate}
                        columnsInspection={columnsInspection}
                        setColumnsInspection={setColumnsInspection}
                        listInspection={listInspection}
                        setListInspection={setListInspection}
                        detailDamage={detailDamage}
                        setDetailDamage={setDetailDamage}
                        rowInspection={rowInspection}
                        setRowInspection={setRowInspection}
                        rowIndexInspection={rowIndexInspection}
                        setRowIndexInspection={setRowIndexInspection}
                        inspectoinResult={inspectoinResult}
                        setInspectoinResult={setInspectoinResult}
                      />
                    ) : (
                      <ErrorPermissionPage />
                    )}
                  </>
                )}
              </>
            </CardBody>
          </Card>
        </>
      )}
    </>
  );
};
